"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

var _help = _interopRequireDefault(require("./help.style"));

var _events = _interopRequireDefault(require("../../utils/helpers/events/events"));

var _utils = require("../../style/utils");

var _help2 = require("./help.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const Help = ({
  className,
  href,
  helpId,
  children,
  tabIndex,
  as,
  tooltipPosition,
  isFocused,
  type,
  tooltipBgColor,
  tooltipFontColor,
  tooltipFlipOverrides,
  ...rest
}) => {
  const helpElement = (0, _react.useRef)(null);
  const [isTooltipVisible, updateTooltipVisible] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    document.addEventListener("keydown", handleKeyPress);
    return function cleanup() {
      document.removeEventListener("keydown", handleKeyPress);
    };
  });
  const tagType = as || href && "a";

  function handleKeyPress(ev) {
    if (_events.default.isEscKey(ev)) {
      helpElement.current.blur();
      updateTooltipVisible(false);
    }
  }

  function handleFocusBlur(bool) {
    return () => {
      updateTooltipVisible(bool);
    };
  }

  return /*#__PURE__*/_react.default.createElement(_help.default, _extends({
    role: "tooltip",
    className: className,
    as: tagType,
    href: href,
    id: helpId,
    target: "_blank",
    rel: "noopener noreferrer",
    ref: helpElement,
    onClick: () => {
      helpElement.current.focus();
    },
    onFocus: handleFocusBlur(true),
    onBlur: handleFocusBlur(false),
    onMouseOver: handleFocusBlur(true),
    onMouseLeave: handleFocusBlur(false)
  }, (0, _tags.default)("help", rest), {
    tabIndex: tabIndex
  }, (0, _utils.filterStyledSystemMarginProps)(rest), rest), /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: type,
    tooltipMessage: children,
    tooltipPosition: tooltipPosition,
    tooltipVisible: isFocused || isTooltipVisible,
    tooltipBgColor: tooltipBgColor,
    tooltipFontColor: tooltipFontColor,
    tooltipFlipOverrides: tooltipFlipOverrides
  }));
};

Help.propTypes = { ...marginPropTypes,

  /** [Legacy] A custom class name for the component. */
  className: _propTypes.default.string,

  /** Message to display in tooltip */
  children: _propTypes.default.node,

  /** The unique id of the component (used with aria-describedby for accessibility) */
  helpId: _propTypes.default.string,

  /** Overrides the default tabindex of the component */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Overrides the default 'as' attribute of the Help component */
  as: _propTypes.default.string,

  /** Position of tooltip relative to target */
  tooltipPosition: _propTypes.default.oneOf(["bottom", "left", "right", "top"]),

  /** A path for the anchor */
  href: _propTypes.default.string,

  /** A boolean received from IconWrapper */
  isFocused: _propTypes.default.bool,

  /** <a href="https://brand.sage.com/d/NdbrveWvNheA/foundations#/icons/icons" target="_blank">List of supported icons</a>
   *
   * Icon to display, can be received from label component
   *
   */
  type: _propTypes.default.string,

  /** Override background color of the Tooltip, provide any color from palette or any valid css color value. */
  tooltipBgColor: _propTypes.default.string,

  /** Override font color of the Tooltip, provide any color from palette or any valid css color value. */
  tooltipFontColor: _propTypes.default.string,

  /** Overrides the default flip behaviour of the Tooltip, must be an array containing some or all of ["top", "bottom", "left", "right"] (see https://popper.js.org/docs/v2/modifiers/flip/#fallbackplacements) */
  tooltipFlipOverrides: (props, propName, componentName) => {
    const prop = props[propName];
    const isValid = prop && Array.isArray(prop) && prop.every(placement => _help2.HELP_POSITIONS.includes(placement));

    if (!prop || isValid) {
      return null;
    }

    return new Error( // eslint-disable-next-line max-len
    `The \`${propName}\` prop supplied to \`${componentName}\` must be an array containing some or all of ["top", "bottom", "left", "right"].`);
  }
};
Help.defaultProps = {
  tooltipPosition: "top",
  tabIndex: 0,
  type: "help"
};
var _default = Help;
exports.default = _default;